import type { Seq } from "../contract/chat.events";
import type { AckDataOf, ClientAck, ClientEventName, PayloadOf } from "./types";

/**
 * What hooks and components may ask of the realtime layer. The runtime (which
 * pulls in socket.io-client) is loaded lazily after login and registers
 * itself here, so this module stays tiny and in the main bundle.
 */
export interface ChatTransport {
  emit<E extends ClientEventName>(event: E, payload: PayloadOf<E>): Promise<ClientAck<AckDataOf<E>>>;
  isConnected(): boolean;
  markDelivered(conversationId: string, seq: Seq): void;
  kickOutbox(): void;
}

let current: ChatTransport | null = null;

export function setChatTransport(transport: ChatTransport | null): void {
  current = transport;
}

export function getChatTransport(): ChatTransport | null {
  return current;
}

const notReady = { ok: false as const, error: { code: "CHAT_NETWORK" as const, message: "chat runtime not started" } };

export async function chatEmit<E extends ClientEventName>(
  event: E,
  payload: PayloadOf<E>,
): Promise<ClientAck<AckDataOf<E>>> {
  return current ? current.emit(event, payload) : notReady;
}
